import LcView from "lib/shared/view";
import helpOnDemandPromo from "views/shared/help_on_demand/promo";

export default LcView.create({
  handleHelpOnDemandPromoClick() {},

  ready() {
    this.hodPromoIsRevealed = false;
    setTimeout(() => {
      helpOnDemandPromo.setOffset();
      this.hodPromoIsRevealed = true;
    }, 3000);
    helpOnDemandPromo.ready();
    this.setListeners();
  },

  selectors: {
    BOOK_COMPONENT: ".book-component",
    HOD_PROMO_CTA: ".hod-promo__cta"
  },

  setListeners() {
    $(window).on("resize", () => {
      if (this.hodPromoIsRevealed) {
        helpOnDemandPromo.setOffset();
      }
    });
    $(this.selectors.HOD_PROMO_CTA).click(() => {
      this.handleHelpOnDemandPromoClick();
    });
  }
});
